import { render, staticRenderFns } from "./followRecord.vue?vue&type=template&id=7b2a007f&scoped=true"
import script from "./followRecord.vue?vue&type=script&lang=js"
export * from "./followRecord.vue?vue&type=script&lang=js"
import style0 from "./followRecord.vue?vue&type=style&index=0&id=7b2a007f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2a007f",
  null
  
)

export default component.exports